<template>
  <UserSummaryPopover :account="account">
    <span class="primary--text">{{ `${getFullName(account)} ` }}</span>
  </UserSummaryPopover>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'
import UserSummaryPopover from '@/components/UserSummaryPopover.vue'

export default {
  name: 'CardMention',

  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  mixins: [mixin, userMixin],

  components: { UserSummaryPopover },

  methods: {
    goToProfile() {
      this.navigateTo({
        name: 'profile',
        params: {
          organizationId: this.account?.organization,
          userId: this.account?._id,
        },
      })
    },
  },
}
</script>
